export const MGA_REPORT_KEYS = [
  'close-pack',
  'payslips',
  'remittance',
  'bank-csv',
  'cash-book',
  'bonded-by-crew',
] as const;

export type MgaReportKey = (typeof MGA_REPORT_KEYS)[number];

export function isMgaReportKey(value: string | undefined): value is MgaReportKey {
  return !!value && (MGA_REPORT_KEYS as readonly string[]).includes(value);
}

export const MGA_REPORT_META: Record<
  MgaReportKey,
  { title: string; subtitle: string; download?: 'excel' | 'csv' }
> = {
  'close-pack': {
    title: "Master's close pack",
    subtitle: 'Brought forward, wages, cash, bonded, allotments (full PDF)',
  },
  payslips: {
    title: 'Bulk payslips',
    subtitle: 'All crew monthly pay accounts',
  },
  remittance: {
    title: 'Allotment remittance',
    subtitle: 'Crew / allottee / bank / amount',
    download: 'excel',
  },
  'bank-csv': {
    title: 'Allotment bank file',
    subtitle: 'Fixed columns for bank upload',
    download: 'csv',
  },
  'cash-book': {
    title: 'Cash book statement',
    subtitle: 'Income / CTM and Cash out with running balance',
  },
  'bonded-by-crew': {
    title: 'Bonded by crew',
    subtitle: 'Stock out and crew bonded charges grouped by crew',
    download: 'excel',
  },
};

export function formatReportMoney(n: number | null | undefined) {
  if (n == null || !Number.isFinite(Number(n))) return '—';
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n));
}

export function reportNum(v: number | null | undefined) {
  return Number.isFinite(Number(v)) ? Number(v) : 0;
}

export function reportRound2(v: number) {
  return Math.round(v * 100) / 100;
}

export function cashEntryTypeLabel(entryType: string) {
  if (entryType === 'EXPENSE') return 'Cash out';
  if (entryType === 'CTM') return 'CTM';
  if (entryType === 'INCOME') return 'Income';
  return entryType;
}
